// extracted by mini-css-extract-plugin
export default {"container":"TextAreaInput_container__w8MaS"};